const slugs = {
  products: 'productos',
  managementCompanies: 'gestoras',
  categories: 'categoria',
  category: 'categorias',
  comparison: 'comparador',
  superComparison: 'supercomparador'
};
const getCategoriesPath = function (productType) {
  let macrocategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'todos';
  return `/${productType.slug}/${slugs.categories}/${macrocategory}`;
};
const getCategoryPath = (productType, category) => `/${productType.slug}/${slugs.category}/${category.id}-${category.alias}`;
export { getCategoriesPath, getCategoryPath };